import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { CheckRewardCodeRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { CheckRewardCodeResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const checkRewardCode = (request: CheckRewardCodeRequest, options?: CashRequestOptions) =>
  post<CheckRewardCodeRequest, CheckRewardCodeResponse>('/2.0/cash/check-reward-code', request, {
    ...options,
    rejectOnError: true,
  })
